import { render, staticRenderFns } from "./TicketComment.vue?vue&type=template&id=08f3639e&scoped=true"
import script from "./TicketComment.vue?vue&type=script&lang=js"
export * from "./TicketComment.vue?vue&type=script&lang=js"
import style0 from "./TicketComment.vue?vue&type=style&index=0&id=08f3639e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3639e",
  null
  
)

export default component.exports